import React from 'react'
import moment from 'moment'

import {Modal, ModalHeader, Button, Card, Colors} from '../UI/index.js'
import {formSpacing, FormRow, FormStack, Input, TextArea, Check, DatePicker, TimePicker, Select} from '../UI/forms/index.js'

import AdminActions from '../../actions/AdminActions.js'
import NotificationsPopup from './NotificationsPopup.js'

const newNotification = () => ({
    title: '',
    moreInfoUrl: '',
    message: '',
    imageSrc: '',
    recipients: [],
    resellerGroups: [],
    scheduleDate: '',
    scheduleTime: '',
    scheduleNotification: false
})

class CreateNotification extends React.Component {
    constructor(props) {
        super(props)

        this.initialState = {
            modalIsOpen: false,
            notification: newNotification()
        }

        this.state = JSON.parse(JSON.stringify(this.initialState))
    }

    open(notification) {
        if (notification) {
            this.setState({notification: structuredClone(notification), modalIsOpen: true})
        } else {
            this.setState({modalIsOpen: true})
        }

        this.previewPopupRef?.open()
    }

    close() {
        this.setState(this.initialState)
    }

    onChangeValue(key, event) {
        const {notification} = this.state

        notification[key] = event.target.value

        this.setState({notification})
    }

    onChangeChecked(key, event) {
        const {notification} = this.state

        notification[key] = event.target.checked

        if (key === 'scheduleNotification') {
            if (event.target.checked) {
                notification.scheduleDate = moment().format('YYYY-MM-DD')
                notification.scheduleTime = moment().format('HH:mm')
            } else {
                notification.scheduleDate = ''
                notification.scheduleTime = ''
            }
        }

        this.setState({notification})
    }

    onChangeRecipients(recipient) {
        const {notification, notification: {recipients}} = this.state
        const index = recipients.findIndex((r) => r === recipient)
        const includes = index > -1

        if (includes) {
            recipients.splice(index, 1)
        } else {
            recipients.push(recipient)
        }

        notification.recipients = recipients

        if (!recipients.length) {
            notification.resellerGroups = []
        }

        this.setState({notification})
    }

    onChangeValues(key, event) {
        const {notification} = this.state

        notification[key] = event.target.values

        this.setState({notification})
    }

    onInsertImage(event) {
        const {notification} = this.state
        const reader = new FileReader()

        reader.onloadend = (event) => {
            notification.imageSrc = event.target.result
            this.setState({notification})
        }

        reader.readAsDataURL(event.target.files[0])
    }

    onCreateNotification() {
        const {notification} = this.state
        AdminActions.createNotification(notification, (err) => {
            if (err) {
                console.log(err)
                alert('Error')
            } else {
                this.close()
                this.setState({notification: newNotification()})
            }
        })
    }

    onUpdateNotification() {
        const {notification} = this.state
        AdminActions.updateNotification(notification, (err) => {
            if (err) {
                console.log(err)
                alert('Error')
            } else {
                this.close()
                this.setState({notification: newNotification()})
            }
        })
    }

    render() {
        const {modalIsOpen, notification} = this.state
        const {_id, title, moreInfoUrl, message, imageSrc, recipients, resellerGroups = [], scheduleDate, scheduleTime, scheduleNotification} = notification
        const {resellers = []} = this.props

        const groupOptions = [...new Set([...resellers.flatMap(({groups}) => groups || []), ...resellerGroups])]
            .sort()
            .map((group) => ({value: group, title: group}))

        return (
            <div>
                <Modal style={{marginLeft: -400}} show={modalIsOpen} onClose={this.close.bind(this)}>
                    <div style={{position: 'relative'}}>
                        <ModalHeader title={_id ? 'Bewerk notificatie' : 'Nieuwe notificatie'} onClose={this.close.bind(this)} />

                        <FormStack style={{marginBottom: formSpacing.rowGap}}>
                            <Input label='Titel' value={title} onChange={this.onChangeValue.bind(this, 'title')} />

                            <TextArea
                                label='Bericht'
                                value={message}
                                rows={6}
                                onChange={this.onChangeValue.bind(this, 'message')}
                            />

                            <Input label='Meer informatie link' value={moreInfoUrl} onChange={this.onChangeValue.bind(this, 'moreInfoUrl')} />
                        </FormStack>

                        <div style={{marginBottom: 20}}>
                            <label htmlFor='insertNotificationImage'>Afbeelding</label>
                            <br />
                            <input id='insertNotificationImage' type='file' accept='image/*' onChange={this.onInsertImage.bind(this)} />

                            <img style={{display: 'block', margin: 'auto', maxWidth: '50%'}} src={imageSrc} />
                        </div>

                        <div style={{marginBottom: 20}}>
                            <Check label='Resellers/vervoerders' checked={recipients.includes('resellers')} onChange={this.onChangeRecipients.bind(this, 'resellers')} />
                            <Check label='Customers/klanten' checked={recipients.includes('customers')} onChange={this.onChangeRecipients.bind(this, 'customers')} />
                            <Check label='Messengers/Koeriers' checked={recipients.includes('messengers')} onChange={this.onChangeRecipients.bind(this, 'messengers')} />
                        </div>

                        <FormStack style={{marginBottom: formSpacing.rowGap}}>
                            {recipients.length > 0 && (
                                <Select
                                    label='Reseller-groepen'
                                    info='Laat leeg om iedereen te bereiken. Klanten en koeriers krijgen de notificatie alleen als hun vervoerder in een gekozen groep zit.'
                                    values={resellerGroups}
                                    options={groupOptions}
                                    onChange={this.onChangeValues.bind(this, 'resellerGroups')}
                                />
                            )}

                            <Check
                                label='Notificatie plannen'
                                checked={scheduleNotification}
                                onChange={this.onChangeChecked.bind(this, 'scheduleNotification')}
                            />
                            {scheduleNotification && (
                                <FormRow>
                                    <DatePicker
                                        style={{width: 182.5}}
                                        label='Datum'
                                        value={scheduleDate}
                                        onChange={(e) => {
                                            this.setState({notification: {
                                                ...notification,
                                                scheduleDate: e.target.value
                                            }})
                                        }}
                                    />
                                    <TimePicker
                                        style={{width: 172.5}}
                                        label='Tijd'
                                        value={scheduleTime}
                                        onChange={(e) => {
                                            this.setState({notification: {
                                                ...notification,
                                                scheduleTime: e.target.value
                                            }
                                            })
                                        }}
                                    />
                                </FormRow>
                            )}
                        </FormStack>

                        <br />
                        <br />

                        {_id ?
                            <Button onClick={this.onUpdateNotification.bind(this)}>Opslaan</Button> :
                            <Button onClick={this.onCreateNotification.bind(this)}>Aanmaken</Button>
                        }
                        <Card style={{position: 'absolute', top: 0, left: 800, width: 500, overflowY: 'auto', padding: 12, paddingLeft: 32, paddingRight: 32, backgroundColor: Colors.backgroundNeutral}}>
                            <NotificationsPopup
                                ref={(ref) => this.previewPopupRef = ref}
                                previewNotification={modalIsOpen ?
                                    {
                                        title,
                                        moreInfoUrl,
                                        message,
                                        imageSrc,
                                        scheduleDate,
                                        scheduleTime
                                    } :
                                    undefined}
                            />
                        </Card>
                    </div>
                </Modal>
            </div>
        )
    }
}

export default CreateNotification
